import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrAdminMcpKeyStatus.ts
var t = () => e("adminMcpKeyStatus");
//#endregion
export { t as useTrAdminMcpKeyStatus };
